import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { interval } from 'rxjs';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { isPlatformBrowser } from '@angular/common';
import { filter, map, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UpdateSwService {

    constructor(public updates: SwUpdate, @Inject(PLATFORM_ID)
    private platformId: any) {

    }

    public init() {
        //check for any updates
        this.checkForUpdates();
        if (isPlatformBrowser(this.platformId)) {
            if (this.updates.isEnabled) {
                // check for updates every hour
                interval(1000 * 60 * 60).subscribe(() => this.updates.checkForUpdate());
            }
        }
    }

    public checkForUpdates(): void {
        if (isPlatformBrowser(this.platformId)) {
            const updatesAvailable = this.updates.versionUpdates.pipe(
                tap(evt =>{
                    switch (evt.type) {
                        case 'VERSION_DETECTED':
                          console.log(`Downloading new app version: ${evt.version.hash}`);
                          break;
                        case 'VERSION_READY':
                          console.log(`Current app version: ${evt.currentVersion.hash}`);
                          console.log(`New app version ready for use: ${evt.latestVersion.hash}`);
                          break;
                        case 'VERSION_INSTALLATION_FAILED':
                          console.log(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
                          break;
                      }
                }),
                filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
                map(evt => {
                    /**@Test */
                    console.log("is new version? ",evt.currentVersion.hash != evt.latestVersion.hash)  
                    return {
                    type: 'UPDATE_AVAILABLE',
                    current: evt.currentVersion,
                    available: evt.latestVersion,
                }})).subscribe(res => {
                    if (res.current.hash != res.available.hash) {
                        this.promptUser();
                    }
                });
            // this.updates.available.subscribe(event => this.promptUser());
        }
    }

    private promptUser(): void {
        this.updates.activateUpdate().then(() => document.location.reload());
    }
}